<div class="row form-group">
  <div class="col-xl-12 col-xxl-4">
    <label for="themeSelect">theme</label>
  </div>
  <div class="col-xl-12 col-xxl-8">
    <select [(ngModel)]="layer"
            id="themeSelect"
            (ngModelChange)="layerChanged()"
            class="form-control form-control-sm">
      <option *ngFor="let l of layers" [ngValue]="l">{{l.label}}</option>
    </select>
  </div>
</div>

<div *ngIf="layerVariants?.length" class="row form-group">
  <!-- <div class="btn-group" role="group">
    <button *ngFor="let lyr of layers" type="button" class="btn btn-primary"
            [ngClass]="{'active':lyr===layer}"
            [ngbTooltip]="lyr.label"
            (click)="setLayer(lyr)">
      <span *ngIf="!lyr.icon">{{lyr.label}}</span>
      <i *ngIf="lyr.icon" class="fa" [ngClass]="lyr.icon"></i>
    </button>
  </div> -->
  <div class="col-xl-12 col-xxl-4">
    <label for="variantSelect">variable</label>
  </div>
  <div class="col-xl-12 col-xxl-8">
      <select class="form-control form-control-sm"
            id="variantSelect"
            [(ngModel)]="selectedVariant"
            [disabled]="!layerVariants?.length"
            (ngModelChange)="variantChanged()"
            [ngbTooltip]="'Variant'">
      <option *ngFor="let variant of layerVariants" [ngValue]="variant">{{variant.variantLabel}}</option>
    </select>
  </div>
</div>

<div class="row form-group">
  <div class="col-xl-12 col-xxl-4">
    <label for="dataMode">metric</label>
  </div>
  <div class="col-xl-12 col-xxl-8">
      <select class="form-control form-control-sm"
            id="dataMode"
            [(ngModel)]="dataMode"
            [disabled]="!dataModes?.length"
            (ngModelChange)="dataModeChanged()"
            [ngbTooltip]="'Data mode'">
      <option *ngFor="let mode of dataModes" [ngValue]="mode.mode">{{mode.label}}</option>
    </select>
  </div>
</div>

<div class="row form-group">
  <div class="col-xl-12 col-xxl-4">
    <label for="choropleth-section">map type</label>
  </div>
  <div class="col-xl-12 col-xxl-8">
    <select [(ngModel)]="choropleth"
            (ngModelChange)="choroplethToggled()"
            [disabled]="!choroplethAvailable"
            class="form-control form-control-sm">
      <option [ngValue]="false">Grid (spatial details)</option>
      <option [ngValue]="true">Regional averages</option>
    </select>
  </div>
</div>

<!--
              [disabled]="!dataModes?.length||!layer?.dataModes"

-->